require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = XE5P
// module chunks = 5 6 7 8